var _regeneratorRuntime = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/jenkins_home/workspace/oc-chat/node_modules/@babel/runtime/helpers/createClass");

var adapter = require('webrtc-adapter');

var JanusLib = require('../libs/janus.es');

var Videoroom = require('./Videoroom');

var SIP = require('./SIP');

var delay = function delay(millis) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, millis);
  });
};

var Janus =
/*#__PURE__*/
function () {
  "use strict";

  function Janus() {
    _classCallCheck(this, Janus);

    this.janus = null;
  }

  _createClass(Janus, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(uri, turn) {
        var _this = this;

        var debug,
            initJanus,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                debug = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;

                initJanus = function initJanus() {
                  return new Promise(function (resolve, reject) {
                    JanusLib.init({
                      debug: debug,
                      dependencies: JanusLib.useDefaultDependencies({
                        adapter: adapter
                      }),
                      callback: function callback() {
                        _this.janus = new JanusLib({
                          server: uri,
                          iceServers: [{
                            "urls": "stun:".concat(turn.host),
                            "credential": turn.password,
                            "username": turn.user
                          }, {
                            "urls": "turn:".concat(turn.host),
                            "credential": turn.password,
                            "username": turn.user
                          }],
                          success: function success() {
                            resolve();
                          },
                          error: function error(_error) {
                            return reject(_error);
                          }
                        });
                      }
                    });
                  });
                };

                return _context2.abrupt("return", new Promise(
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee(resolve, reject) {
                    var i;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!_this.janus) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return", resolve());

                          case 2:
                            if (JanusLib.isWebrtcSupported()) {
                              _context.next = 4;
                              break;
                            }

                            return _context.abrupt("return", reject('No WebRTC support'));

                          case 4:
                            i = 0;

                          case 5:
                            if (!(i < 3)) {
                              _context.next = 22;
                              break;
                            }

                            _context.prev = 6;
                            debug && console.log("Janus init: Attempt n. ".concat(i + 1));
                            _context.next = 10;
                            return initJanus();

                          case 10:
                            resolve();
                            return _context.abrupt("break", 22);

                          case 14:
                            _context.prev = 14;
                            _context.t0 = _context["catch"](6);
                            console.error(_context.t0);
                            _context.next = 19;
                            return delay(2000);

                          case 19:
                            i++;
                            _context.next = 5;
                            break;

                          case 22:
                            return _context.abrupt("return", reject(new Error('Could not initialize Janus')));

                          case 23:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this, [[6, 14]]);
                  }));

                  return function (_x3, _x4) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getVideoroom",
    value: function () {
      var _getVideoroom = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var videoroom;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                videoroom = new Videoroom(this.janus);
                _context3.prev = 1;
                _context3.next = 4;
                return videoroom.init();

              case 4:
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](1);
                throw _context3.t0;

              case 9:
                return _context3.abrupt("return", videoroom);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 6]]);
      }));

      function getVideoroom() {
        return _getVideoroom.apply(this, arguments);
      }

      return getVideoroom;
    }()
  }, {
    key: "getSIP",
    value: function () {
      var _getSIP = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var sip;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                sip = new SIP(this.janus);
                _context4.prev = 1;
                _context4.next = 4;
                return sip.init();

              case 4:
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](1);
                throw _context4.t0;

              case 9:
                return _context4.abrupt("return", sip);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 6]]);
      }));

      function getSIP() {
        return _getSIP.apply(this, arguments);
      }

      return getSIP;
    }()
  }, {
    key: "destroy",
    value: function () {
      var _destroy = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", new Promise(function (resolve, reject) {
                  if (!_this2.janus) return reject('no janus');

                  _this2.janus.destroy({
                    success: resolve
                  });
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function destroy() {
        return _destroy.apply(this, arguments);
      }

      return destroy;
    }()
  }, {
    key: "attachMediaStream",
    value: function attachMediaStream(element, stream) {
      JanusLib.attachMediaStream(element, stream);
    }
  }, {
    key: "isExtensionEnabled",
    value: function isExtensionEnabled() {
      return JanusLib.isExtensionEnabled();
    }
  }]);

  return Janus;
}();

module.exports = Janus;